import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { togglePopup } from 'apps/auth/actions/appAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const SearchAddressNotFoundPopup = (props) => {
    const { searchAddressNotFoundTitle, searchAddressNotFoundText, morePopupButtonClose } = usePageMessages();

    const onClick = () => {
        if (props.onClick) {
            props.onClick();
        }

        props.togglePopup(false);
    };

    return (
        <SimplePopup
            text={
                <>
                    <p>{searchAddressNotFoundTitle}</p>
                    <p>{searchAddressNotFoundText}</p>
                </>
            }
        >
            <PopupButton iconName={props.iconName || 'check'} text={morePopupButtonClose} onClick={onClick} />
        </SimplePopup>
    );
};

SearchAddressNotFoundPopup.propTypes = {
    iconName: PropTypes.string,
    onClick: PropTypes.func,
};

export default connect(null, { togglePopup })(SearchAddressNotFoundPopup);
